// SPDX-License-Identifier: AGPL-3.0-or-later

import {ChannelTypes} from '@fluxer/constants/src/ChannelConstants';
import {serializeChannelAppearance} from './ChannelAppearanceUtils';

export const CORET_FEED_CHANNEL_TYPE = 10_000;
export const CORET_MUSIC_CHANNEL_TYPE = 10_001;
export const CORET_MARKETPLACE_CHANNEL_TYPE = 10_002;
export const CORET_RAFFLE_CHANNEL_TYPE = 10_003;

export interface ChannelCreatePresentation {
	channelType: number;
	topic: string | null;
}

export function resolveChannelCreatePresentation(selectedType: number): ChannelCreatePresentation {
	if (
		selectedType !== CORET_FEED_CHANNEL_TYPE &&
		selectedType !== CORET_MUSIC_CHANNEL_TYPE &&
		selectedType !== CORET_MARKETPLACE_CHANNEL_TYPE &&
		selectedType !== CORET_RAFFLE_CHANNEL_TYPE
	) {
		return {channelType: selectedType, topic: null};
	}
	return {
		channelType: selectedType === CORET_MUSIC_CHANNEL_TYPE ? ChannelTypes.GUILD_VOICE : ChannelTypes.GUILD_TEXT,
		topic: serializeChannelAppearance('', {
			color: 0,
			animation: 'none',
			layout:
				selectedType === CORET_MUSIC_CHANNEL_TYPE
					? 'music'
					: selectedType === CORET_MARKETPLACE_CHANNEL_TYPE
						? 'marketplace'
						: selectedType === CORET_RAFFLE_CHANNEL_TYPE
							? 'raffle'
							: 'feed',
		}),
	};
}
